import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table } from 'antd';

class CamdetectTechdatasTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    render() {
        let { sortedInfo, filteredInfo } = this.state;

        const columns = [
            {
                title: 'Napětí baterie [V]',
                dataIndex: 'bat',
                key: 'bat',
                width: 30,
                render: (text, record) => {
                    if (record.bat != 0) {
                        return record.bat.toFixed(2)
                    } else {
                        return "-"
                    }
                }
            }, {
                title: 'Teplota [°C]',
                dataIndex: 'temp',
                key: 'temp',
                width: 30,
                render: (text, record) => {
                    return record.temp.toFixed(2)
                }
            }, {
                title: 'Trvalé napájení',
                dataIndex: 'grid',
                key: 'grid',
                width: 70,
                filters: [{
                    text: 'ANO',
                    value: true,
                }, {
                    text: 'NE',
                    value: false,
                }],
                filteredValue: filteredInfo.grid || null,
                onFilter: (value, record) => {
                    return ((record.grid === value)) ? true : false
                },
                render: (text, record) => {
                    if (record.grid === true) {
                        return "ANO"
                    } else {
                        return "NE"
                    }
                }
            }, {
                title: 'Doba provozu',
                dataIndex: 'uptime',
                key: 'uptime',
                width: 100,
                render: (text, record) => {
                    var uptimeString = "";
                    if (record.uptime != 0) {
                        if (moment.duration(record.uptime, "seconds").days() != 0) {
                            uptimeString += moment.duration(record.uptime, "seconds").days() + ' d ';
                        }
                        if (moment.duration(record.uptime, "seconds").hours() != 0) {
                            uptimeString += moment.duration(record.uptime, "seconds").hours() + ' h ';
                        }
                        if (moment.duration(record.uptime, "seconds").minutes() != 0) {
                            uptimeString += moment.duration(record.uptime, "seconds").minutes() + ' min ';
                        }
                        if (moment.duration(record.uptime, "seconds").seconds() != 0) {
                            uptimeString += moment.duration(record.uptime, "seconds").seconds() + ' s';
                        }
                    } else {
                        uptimeString = "0 s";
                    }
                    return uptimeString;
                }
            }, {
                title: 'Časová značka',
                dataIndex: 'timestamp',
                key: 'timestamp',
                width: 200,
                defaultSortOrder: 'descend',
                sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
                render: (text, record) => {
                    return moment(text).format('L LTS');
                }
            }]
        return (
            <Table
                size='small'
                rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
                loading={this.props.loading ? this.props.loading : false}
                columns={columns}
                dataSource={this.props.data}
                onChange={this.handleChange}
                pagination={{
                    showSizeChanger: true,
                    defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                        ? parseInt(localStorage.getItem('table_pageSize'))
                        : 10,
                    onShowSizeChange: (current, size) => {
                        localStorage.setItem('table_pageSize', size);
                    }
                }}
                style={{ border: '0px' }} />
        );
    }
}

export default CamdetectTechdatasTable;


// WEBPACK FOOTER //
// ./src/components/CamdetectTechdatasTable.js